import { render, staticRenderFns } from "./CreatorPostComments.vue?vue&type=template&id=2cbf36e6&"
import script from "./CreatorPostComments.vue?vue&type=script&lang=js&"
export * from "./CreatorPostComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports